"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SetupContexts = void 0;
const react_1 = __importDefault(require("react"));
const config_1 = require("@geome/react-next/lib/context/config");
const provider_1 = require("@geome/react-next/lib/context/i18nContext/provider");
const cssCustomProperty_1 = require("@geome/react-next/lib/context/cssCustomProperty");
const SetupContexts = ({ config, i18nMode = "production", children, }) => (react_1.default.createElement(config_1.ConfigContextProvider, { value: config },
    react_1.default.createElement(provider_1.I18nContextProvider, { intlData: config.intlData, mode: i18nMode },
        react_1.default.createElement(cssCustomProperty_1.CSSCustomPropertyContextProvider, { properties: {
                "--primary-colour": "#dd1d21",
                "--shell-yellow": "#ffc400",
                "--shell-grey-colour": "#4A4A4A",
                "--shell-grey-400-colour": "#707070",
                "--shell-light-grey-colour": "#d9d9d9",
                "--background-grey-colour": "#f7f7f7",
            } }, children))));
exports.SetupContexts = SetupContexts;
